import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetInvoiceIssuerOptionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { Selector, Option } from '../Selects/Selector';

interface InvoiceIssuerSelectorProps {
  value?: string | null;
  onChange?: (option: Option) => void;
  readOnly?: boolean;
}

export default (props: InvoiceIssuerSelectorProps) => {
  const spd = useSpdCore();
  const [issuers, setIssuers] = useState<GetInvoiceIssuerOptionDto[]>([]);
  const [displayName, setDisplayName] = useState<string>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    spd.invoiceIssuers
      .getAllActive()
      .then(all => {
        if (mounted) {
          setIssuers(all);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem wystawców faktur. ${error}`),
      );
    return () => {
      mounted = false;
    };
  }, [spd.invoiceIssuers]);

  useEffect(() => {
    // Brak wystawcy — backend podstawi domyślnego
    const found = props.value
      ? issuers.find(i => i.id === props.value)
      : issuers.find(i => i.isDefault);
    setDisplayName(found?.name || '');
  }, [props.value, issuers]);

  const provider = async (text: string): Promise<Option[]> =>
    issuers
      .filter(i => (i.name || '').toLowerCase().includes(text.toLowerCase()))
      .map(i => ({ value: i.id, label: i.name || '' }));

  return ready ? (
    <Selector
      uniqueKey={'invoice-issuer-' + JSON.stringify(issuers)}
      readOnly={props.readOnly}
      creatable={false}
      placeholder="Wskaż..."
      provider={provider}
      value={displayName}
      onChange={props.onChange}
    />
  ) : (
    <Skeleton />
  );
};
